<div id="solution-form" style="height: 275px;">
  <form [formGroup]="objectForm" name="otsc-solution-environment-form">
    <div class="ot-mb-1 ot-mt-1 ot-ml-1 ot-mr-1">
      <div class="ot-row">
        <div class="ot-row__column ot-mr-1">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : nameCtrl.touched && nameCtrl.invalid}">
            <label for="name" class="ot-form-control__label">
              @if (!nameCtrl.disabled) {
              <span class="ot-form-control--is-required">*</span>
              }
              <span i18n>Name</span>
            </label>
            <input id="name" name="name" formControlName="nameCtrl" placeholder="Enter name" type="text"
              class="ot-input" maxlength="50">
            @if (nameCtrl.touched && nameCtrl.invalid && nameCtrl.errors.required) {
            <p id="nameErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
              Name cannot be empty.
            </p>
            }
            @if (nameCtrl.errors && nameCtrl.errors.exists) {
            <p id="existsErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
              Name already exists.
            </p>
            }
          </div>
        </div>
      </div>
      <div class="ot-row">
        <div class="ot-row__column ot-mr-1">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : descriptionCtrl.touched && descriptionCtrl.invalid}">
            <label for="description" class="ot-form-control__label">
              <span i18n>Description</span>
            </label>
            <textarea id="description" name="description" formControlName="descriptionCtrl"
              placeholder="Enter description" class="ot-textarea" maxlength="100" rows="5"></textarea>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>